import { ICreateServicoProdutoUseCase } from "../../../presentation/useCases/create/create_servico_produto_use_case";
import { IComprasRepository } from "../../repositories/compras_repositories";

/**
 * CreateServicoProdutoUseCase
 */

export class CreateServicoProdutoUseCase implements ICreateServicoProdutoUseCase {
  constructor(private readonly repository: IComprasRepository) { }

  async createServicoProduto(
    ativo: boolean,
    produtoServico: string,
    tipo: number,
    unidade: string | undefined,
    norma: string | undefined,
  ): Promise<number> {
    return await this.repository.createServicoProduto(
      ativo,
      produtoServico,
      tipo,
      unidade ?? null,
      norma ?? null,
    );
  }
}
